import { render, staticRenderFns } from "./super_home.vue?vue&type=template&id=fb1b0d74&scoped=true&"
import script from "./super_home.vue?vue&type=script&lang=js&"
export * from "./super_home.vue?vue&type=script&lang=js&"
import style0 from "./super_home.vue?vue&type=style&index=0&id=fb1b0d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1b0d74",
  null
  
)

export default component.exports